import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, leftJoin, nullsafe, unionKey } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MotivosGuiasListMem } from "./listmem";

type ValueItem = models.MotivoCancelacionGuiaModel;
export interface Props {
    value: ValueItem[];
    idFactura: number;
    onChange: (value: ValueItem[]) => PromiseLike<void> | void;
}

/**Listado de los motivos de cancelación por guia */
export class MotivosGuiasList extends React.PureComponent<Props> {
    idFactura = (props: Props) => props.idFactura;
    guiasFactura = createSelectorRx(this.idFactura, idFactura => observeResource(resources.Guia.Query, {
        IdFactura: idFactura
    }));

    render() {
        return <MotivosGuiasListMem
            value={this.props.value}
            onChange={this.props.onChange}
            guias={this.guiasFactura(this.props)}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/list/motivoguias/list.tsx